import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { AdjacentType, edgeTypeMatrix, getEntityRollingProgrammeToEntityEdgeTypeId } from '@iotv/datamodel-core';
import { TypeIcons } from '../../../Iconography';
import { DefaultStepTypeFolderClickWrapper, ObjectTree } from '../../../v2/components/generic/ObjectTree';
import { ContextMenu } from '../ContextMenuV2/ContextMenu';
const debug = process.env.REACT_APP_DEBUG && false;
/** Customer to Rolling Programme */
export const customerRollingProgrammesTreeDef = {
    stepQuery: {
        objectTypeId: 'EntityRollingProgramme',
        adjacencyType: AdjacentType.CHILD,
        edgeTypeId: edgeTypeMatrix.Customer.EntityRollingProgramme.customer_has_entity_rolling_programme.edgeTypeId,
    },
    endIcon: TypeIcons.EntityRollingProgramme,
    nextSteps: [],
    renderTypeFolder: false,
    thisStepTypeFolderClickWrapper: (props) => (_jsx(DefaultStepTypeFolderClickWrapper, { ...props,
        element: _jsx(_Fragment, { children: "Rolling Programmes" }),
        support: 'EntityRollingProgramme' })),
    thisStepLabelWrapper: ({ vob, ascendentAccessor }) => (_jsx(ContextMenu, { ascendentAccessor,
        contextObject: vob,
        popUpElement: null,
        edgeTypeIdFilter: [edgeTypeMatrix.EntityRollingProgramme.Entity.rolling_programme_schedules_entity.edgeTypeId],
        // CRA 2025 05 — disabled as there are special methods required for creating Programmes in a ProgrammeSet which are handled by the ProgrammeSet UI
        hideAdd: true })),
    itemDerivedTreeFn: (vob, nodeEdgeMapper) => {
        return typeof vob.supportedType === 'string'
            ? [
                _jsx(ObjectTree, { contextObjects: [vob],
                    hideTopStep: true,
                    nodeEdgeMapper,
                    queryPaths: [
                        {
                            stepQuery: {
                                objectTypeId: vob.supportedType,
                                adjacencyType: AdjacentType.CHILD,
                                edgeTypeId: getEntityRollingProgrammeToEntityEdgeTypeId(vob.supportedType),
                            },
                        },
                    ] }, vob.sk),
            ]
            : [];
    },
};
